/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useMicrofrontend } from '../context/Microfrontend';
import { useRenderContent } from '../internal/RenderProvider/useRenderContent';
import { serializeParameters } from '@cian/mf-registry/shared/parameters/serialize';
import { PARAMETERS_ATTRIBUTE } from '@cian/mf-registry/shared/webComponent/constants';
const EMPTY_SET_INNER_HTML = { __html: '' };
/**
 * Создает компоненту, которая будет рендерить web-компоненту микрофронтенда
 *
 * Для рендера нужно чтобы в MicrofrontendContext был проброшен текущий микрофронтенд
 * из @cian/mf-registry
 *
 * Если был использован RenderProvider, то будет использоваться контент
 * из getRenderContent() микрофронтенда.
 * При отсутствии контента будет выброшено исключение.
 *
 * @export
 * @template P параметры/пропсы
 * @param {IMicrofrontendIdentityLocation} location
 * @return {*}
 */
export function createComponent({ mcs, path }) {
    function Component(parameters) {
        const microfrontend = useMicrofrontend();
        const WebComponentName = React.useMemo(() => {
            return microfrontend.getChild(mcs).getUIRuntime({ path }).tag;
        }, [microfrontend]);
        const content = useRenderContent(mcs, path, parameters);
        return (React.createElement(WebComponentName, { ...{ [PARAMETERS_ATTRIBUTE]: serializeParameters(parameters) }, dangerouslySetInnerHTML: content ? { __html: content } : EMPTY_SET_INNER_HTML, suppressHydrationWarning: true }));
    }
    Component.displayName = `MicrofrontendUIComponent(${mcs}${path})`;
    return Component;
}
//# sourceMappingURL=createComponent.js.map